// src/utils/collegeColors.js
// Accent colors for each university based on their official branding

export const getCollegeAccentColor = (collegeName) => {
  const colorMap = {
    // Ivy League
    'Princeton University': '#FF8F00', // Princeton Orange
    'Harvard University': '#A51C30', // Harvard Crimson
    'Yale University': '#00356B', // Yale Blue
    'Columbia University': '#B9D9EB', // Columbia Blue (lighter)
    'University of Pennsylvania': '#011F5B', // Penn Blue
    'Dartmouth College': '#00693E', // Dartmouth Green
    'Brown University': '#8B4513', // Brown
    'Cornell University': '#B31B1B', // Cornell Red
    
    // Top Tech Schools
    'Massachusetts Institute of Technology': '#8B0000', // MIT Red
    'Stanford University': '#8C1515', // Stanford Cardinal
    'California Institute of Technology': '#FF6C0C', // Caltech Orange
    
    // Other Elite Private Universities
    'University of Chicago': '#8A0000', // University of Chicago Maroon
    'Northwestern University': '#4E2A84', // Northwestern Purple
    'Duke University': '#003087', // Duke Blue
    'Johns Hopkins University': '#002D72', // Hopkins Blue
    'Vanderbilt University': '#B69968', // Vanderbilt Gold
    'Rice University': '#003087', // Rice Blue
    'Emory University': '#1C4587', // Emory Blue
    'Georgetown University': '#041E42', // Georgetown Blue
    'Carnegie Mellon University': '#C41E3A', // Carnegie Red
    'University of Notre Dame': '#0C2340', // Notre Dame Navy
    'Wake Forest University': '#9E7E38', // Wake Forest Gold
    'Tufts University': '#3E8EDE', // Tufts Blue
    'Boston College': '#8B0000', // Boston College Maroon
    'New York University': '#57068C', // NYU Violet
    'University of Southern California': '#990000', // USC Cardinal
    'Brandeis University': '#003478', // Brandeis Blue
    'Lehigh University': '#8B4513', // Lehigh Brown
    'Villanova University': '#000080', // Villanova Navy
    
    // Top Public Universities
    'University of California Berkeley': '#003262', // UC Berkeley Blue
    'University of California Los Angeles': '#2774AE', // UCLA Blue
    'University of Michigan': '#00274C', // Michigan Navy
    'University of Virginia': '#232D4B', // UVA Navy
    'University of North Carolina Chapel Hill': '#4B9CD3', // Carolina Blue
    'Georgia Institute of Technology': '#B3A369', // Georgia Tech Gold
    'University of California San Diego': '#182B49', // UCSD Navy
    'University of California Davis': '#022851', // UC Davis Navy
    'University of California Santa Barbara': '#003660', // UCSB Navy
    'University of California Irvine': '#0064A4', // UCI Blue
    'University of Florida': '#0021A5', // Florida Blue
    'University of Texas Austin': '#BF5700', // Texas Orange
    'University of Washington': '#4B2E83', // Washington Purple
    'University of Wisconsin Madison': '#C5050C', // Wisconsin Red
    'Pennsylvania State University': '#041E42', // Penn State Navy
    'Ohio State University': '#BB0000', // Ohio State Scarlet
    'University of Illinois Urbana-Champaign': '#13294B', // Illinois Navy
    'Purdue University': '#CEB888', // Purdue Gold
    'University of Minnesota Twin Cities': '#FFCC33', // Minnesota Gold
    'College of William & Mary': '#115740', // William & Mary Green
    'North Carolina State University': '#CC0000', // NC State Red
    'Stony Brook University (SUNY)': '#990000', // Stony Brook Red
    'Virginia Tech': '#861F41', // Virginia Tech Maroon
    'University of Connecticut': '#000E2F', // UConn Navy
    'University of Delaware': '#046A38', // Delaware Green
    'University of Maryland': '#E03A3E', // Maryland Red
    'Rutgers University': '#CC0033', // Rutgers Scarlet
    'University of Pittsburgh': '#003594', // Pitt Blue
    'Indiana University': '#990000', // Indiana Crimson
    'Michigan State University': '#18453B', // Michigan State Green
    'University of Iowa': '#FFCD00', // Iowa Gold
    'Arizona State University': '#8C1D40', // ASU Maroon
    'University of Arizona': '#AB0520', // Arizona Red
    'University of Colorado Boulder': '#CFB87C', // Colorado Gold
    'University of Oregon': '#154733', // Oregon Green
    'Florida State University': '#782F40', // FSU Garnet
    'University of South Carolina': '#73000A', // South Carolina Garnet
    'University of Alabama': '#9E1B32', // Alabama Crimson
    'Auburn University': '#0C2340', // Auburn Navy
    'University of Georgia': '#BA0C2F', // Georgia Red
    'University of Tennessee': '#FF8200', // Tennessee Orange
    'Louisiana State University': '#461D7C', // LSU Purple
    'University of Arkansas': '#9D2235', // Arkansas Cardinal
    'University of Kentucky': '#0033A0', // Kentucky Blue
    'University of Mississippi': '#14213D', // Ole Miss Navy
    'Mississippi State University': '#5D1725', // Mississippi State Maroon
    'Texas A&M University': '#732F2F', // Texas A&M Maroon (lighter version)
    'University of Oklahoma': '#841617', // Oklahoma Crimson
    'Oklahoma State University': '#FF7300', // Oklahoma State Orange
    'University of Kansas': '#0051BA', // Kansas Blue
    'Kansas State University': '#512888', // Kansas State Purple
    'University of Nebraska Lincoln': '#D00000', // Nebraska Red
    'Iowa State University': '#C8102E', // Iowa State Cardinal
    'University of Missouri': '#F1B82D', // Missouri Gold
    'Colorado State University': '#1E4D2B', // Colorado State Green
    'University of Utah': '#CC0000', // Utah Red
    'Utah State University': '#0F2439', // Utah State Navy
    'Boise State University': '#0033A0', // Boise State Blue
    'University of Nevada Las Vegas': '#CF0A2C', // UNLV Red
    'San Diego State University': '#BA0C2F', // SDSU Red
    'California State University Northridge': '#C8102E', // CSUN Red
    'San Jose State University': '#0055A2', // SJSU Blue
  };
  
  return colorMap[collegeName] || '#3498db'; // Default blue if college not found
};

// Function to get a lighter version of the accent color for backgrounds
export const getCollegeAccentColorLight = (collegeName) => {
  const baseColor = getCollegeAccentColor(collegeName);
  // Convert hex to RGB, lighten it, and return
  const hex = baseColor.replace('#', '');
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);
  
  // Create a lighter version by blending with white
  const lightR = Math.round(r + (255 - r) * 0.85);
  const lightG = Math.round(g + (255 - g) * 0.85);
  const lightB = Math.round(b + (255 - b) * 0.85);
  
  return `rgb(${lightR}, ${lightG}, ${lightB})`;
}; 